export default __webpack_public_path__ + "static/media/d-f.cb27e752.png";